<template>
  <el-container
    id="pagar-container"
    style="justify-content:center; align-items:center"
    v-loading.fullscreen.lock="loading"
  >
    <el-col
      :xs="24"
      :sm="20"
      :md="15"
      :lg="10"
    >
      <el-row type="flex" justify="end">
        <el-col
          :xs="24"
          :sm="5"
        >
          <el-button
            type="primary"
            @click="$goBack()"
            style="width:100%"
          >
            Volver
          </el-button>
        </el-col>
      </el-row>
      <div class="cart-wrapper">
        <div class="cart-title">
          <h1 class="cart-title__inner">
            Cargos seleccionados
          </h1>
        </div>
        <div class="custom-table">
          <div
            class="custom-table__body"
          >
            <div class="custom-row">
              <div class="custom-row__field">
                {{ cart.claveCatastral ? 'Clave Catastral' : 'CURT' }}
              </div>
              <div class="custom-row__value">
                {{ cart.claveCatastral || cart.curt }}
              </div>
            </div>
            <div class="custom-row">
              <div class="custom-row__field">
                Descripción
              </div>
              <div class="custom-row__value">
                {{ cart.description }}
              </div>
            </div>
            <div class="custom-row">
              <div class="custom-row__field">
                total
              </div>
              <div class="custom-row__value">
                {{ $currencyFormater(cart.total) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <form
        id="PagoBancomer"
        name="PagoBancomer"
        action="https://www.adquiramexico.com.mx/clb/endpoint/gzapopan"
        target="_parent"
        method="post"
      >
        <input
          id="s_transm"
          name="s_transm"
          type="hidden"
          :value="pk"
        >
        <input
          id="c_referencia"
          name="c_referencia"
          type="hidden"
          :value="lineaBancos"
        >
        <input
          id="val_1"
          name="val_1"
          type="hidden"
          :value="'0'"
        >
        <input
          id="val_2"
          name="val_2"
          type="hidden"
          :value="nombrecompletopropietario"
        >
        <input
          id="t_servicio"
          name="t_servicio"
          type="hidden"
          :value="'2'"
        >
        <input
          id="t_importe"
          name="t_importe"
          type="hidden"
          :value="total"
        >
        <input
          id="val_3"
          name="val_3"
          type="hidden"
          :value="'1'"
        >
        <input
          id="val_4"
          name="val_4"
          type="hidden"
          :value="'1'"
        >
        <input
          id="val_5"
          name="val_5"
          type="hidden"
          :value="'1'"
        >
        <input
          id="val_6"
          name="val_6"
          type="hidden"
          :value="'0'"
        >
        <input
          id="val_17"
          name="val_17"
          type="hidden"
          :value="'0'"
        >
        <!-- Comentar desde aquí sí se esta usando
            https://prepro.adquiracloud.mx/clb/endpoint/gzapopanResponse
            action=https://prepro.adquiracloud.mx/clb/endpoint/gzapopan/
            https://www.adquiramexico.com.mx/clb/endpoint/gzapopan
            action="https://prepro.adquiracloud.mx/clb/endpoint/gzapopan/"
            https://prepro.adquiracloud.mx/clb/endpoint/gzapopan/-->
        <input
          id="mp_account"
          name="mp_account"
          type="hidden"
          :value="'439'"
        >
        <input
          id="mp_product"
          name="mp_product"
          type="hidden"
          :value="'1'"
        >
        <input
          id="mp_customername"
          name="mp_customername"
          type="hidden"
          :value="nombrecompletopropietario"
        >
        <input
          id="mp_node"
          name="mp_node"
          type="hidden"
          :value="'0'"
        >
        <input
          id="mp_currency"
          name="mp_currency"
          type="hidden"
          :value="'1'"
        >
        <input
          id="mp_amount"
          name="mp_amount"
          type="hidden"
          :value="total"
        >
        <input
          id="mp_signature"
          name="mp_signature"
          type="hidden"
          :value="`${mp_signature}`"
        >
        <input
          id="mp_concept"
          name="mp_concept"
          type="hidden"
          :value="'2'"
        >
        <input
          id="mp_order"
          name="mp_order"
          type="hidden"
          :value="pk"
        >
        <input
          id="mp_reference"
          name="mp_reference"
          type="hidden"
          :value="lineaBancos"
        >
        <input
          id="mp_urlsuccess"
          name="mp_urlsuccess"
          type="hidden"
          :value="'https://prepro.adquiracloud.mx/clb/endpoint/gzapopanResponse'"
        >
        <input
          id="mp_urlfailure"
          name="mp_urlfailure"
          type="hidden"
          :value="'https://prepro.adquiracloud.mx/clb/endpoint/gzapopanResponse'"
        >
      </form>
      <br>
      <br>
      <el-row>
        <p>
          <b>
            Realiza tu pago mediante tarjetas bancarias de
            cualquier banco*, elige cualquiera de las siguientes opciones:
          </b>
        </p>
      </el-row>
      <br>
      <el-row
        type="flex" :gutter="10"
        class="payment-row xs-display-unset"
      >
        <el-col :xs="24" :md="12">
          <el-button
            type="primary"
            style="width:100%"
            @click="submit"
          >
            Crédito / Débito / Cheque en línea / CoDi
          </el-button>
        </el-col>
        <el-col :xs="24" :md="12">
          <div class="logo-bbva">
            <img
              src="../assets/images/logo-bbva.png"
              alt="logo bbva"
            >
          </div>
        </el-col>
      </el-row>
      <el-divider />
      <el-row
        type="flex" :gutter="10"
        class="payment-row xs-display-unset"
      >
        <el-col :xs="24" :md="12">
          <el-button
            type="primary"
            style="width:100%"
            @click="submitSantander"
          >
            Crédito / Débito / PROSA
          </el-button>
        </el-col>
        <el-col :xs="24" :md="12">
          <div class="logo-santander">
            <img
              src="../assets/images/logo-santander.png"
              alt="logo santander"
            >
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-footer>
      <img
        src="../assets/images/BancosParticipantes.png"
        alt="instituciones-participantes-wpp.png"
      >
    </el-footer>
  </el-container>
</template>

<script>
import Moment from 'moment';
import { mapState } from 'vuex';

const generate = require('../utils/generateRef');

export default {
  data() {
    return {
      loading: false,
      lineaBancos: null,
      pk: null,
      nombrecompletopropietario: null,
      total: 0,
      mp_signature: null,
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart.data,
      user: (state) => state.predio.user,

    }),
  },
  methods: {
    /**
     * Retorna referencia bancaria
     */
    generateRef() {
      const date = new Moment().format('DD/MM/YYYY');
      const { cuentadepredial } = this.user;
      const ref = cuentadepredial.length === 10
        ? cuentadepredial : this.user.pk.toString().padStart(10, '0');
      const {
        LINEA_BANCOS,
      } = generate(date, this.cart.total, ref);
      this.lineaBancos = LINEA_BANCOS.toString();
      this.pk = this.cart.cuentadepredial || this.cart.claveCatastral || this.cart.curt;
      const name = this.user.nombrecompletopropietario.toString();
      this.nombrecompletopropietario = name.length >= 50 ? name.substr(0, 50) : name;
      this.total = parseFloat(this.cart.total).toFixed(2).toString();
      console.log(`TOTAL CART ${this.total}`);
      console.log(`REFERENCIA EN PAGO PREDIAL ${ref}`);
      console.log(`LINEA BANCOS ${this.lineaBancos}`);
    },
    async getResultado() {
      try {
        this.loading = true;
        const param = `${this.pk.toString()}${this.lineaBancos}${this.total}`;
        const res = await this.axios.post('/Encripta', {
          payload: param,
        });
        console.log(`encripta res ${res}`);
        return res?.data?.resultado;
      } catch {
        return 'error';
      } finally {
        this.loading = false;
      }
    },
    /**
     * Limpia el estado global de la aplicación
     * y redirecciona al usuario a la aplicación de
     * pago.
     */
    async submit() {
      try {
        this.loading = true;
        const resultado = await this.getResultado();
        if (resultado?.toLowerCase() !== 'error') {
          this.mp_signature = resultado;
          console.log(`CARGOS ${this.user.cargos}`);
          // console.log(this.user.cargos.split(";"));
          console.log(this.cart.cargos);
          /* const resGuardarRef = await this.axios.post('/GuardarReferenciaDePago', {
            PadronID: this.user.pk,
            Padron: 'PredioExterno',
            ConceptoAPagar: 1,
            Referencia: this.lineaBancos,
            Cargos: this.user.cargos.split(";"),
            TotalRedondeo: parseFloat(this.cart.extra.toFixed(2)),
            TotalAPagar: parseFloat(this.cart.total.toFixed(2)),
          });
          console.log('resGuardarRef ');
          console.log(resGuardarRef);
          console.log('REFERENCIA '+this.lineaBancos);
          console.log(this.user);
          */
          const { tiene_seguro } = this.user;
          const { tiene_opd } = this.user;
          const { id_consulta } = this.user;
          const { cargos } = this.user;
          const padron_id = this.user.pk;
          const total_redondeo = parseFloat(this.cart.extra.toFixed(2));
          const currentDate = new Moment();
          const currentYear = currentDate.format('YYYY');
          console.log(`anio actual ${currentYear} referencia bancaria ${this.lineaBancos}`);

          const resGuardarRef = await this.axios.post('https://indicadores.zapopan.gob.mx:8080/WSCajaWeb/api/referenciaWeb',
            {
              padron_id,
              total: parseFloat(this.cart.total.toFixed(2)),
              redondeo: total_redondeo,
              idConsulta: id_consulta,
              anio: currentYear,
              bim: 6,
              canalDePago: 11,
              tieneSeguro: tiene_seguro,
              tieneOpd: tiene_opd,
              referencia: this.lineaBancos,
              cargos,

            });

          console.log(resGuardarRef);
          console.log(resGuardarRef?.status);
          console.log(resGuardarRef?.data[0].resultado);
          if (
            resGuardarRef?.status === 200
            && resGuardarRef?.data
            && resGuardarRef?.data[0].resultado == '1') {
            this.$store.dispatch('predio/SET_DATA', []);
            this.$store.dispatch('predio/SET_USER', {});
            this.loading = false;

            setTimeout(() => {
              document.getElementById('PagoBancomer').submit();
            });
          } else {
            this.$ErrorNotify({
              response: {
                data: {
                  alerta: 'Ah ocurrido un proceso inesperado vuelva a intentar más tarde ',
                },
              },
            });
          }
        } else {
          this.$ErrorNotify({
            response: {
              data: {
                alerta: 'Ah ocurrido un proceso inesperado vuelva a intentar más tarde ',
              },
            },
          });
          setTimeout(() => {
            this.$router.push({ path: '/estado-de-cuenta' });
          }, 2000);
        }
      } catch (err) {
        this.$ErrorNotify(err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * Redirecciona al usuario a la vista de continuacion de pago
     * con WebPayPlus
     */
    async submitSantander() {
      this.$store.dispatch('cart/SET_DATA', {
        ref: this.lineaBancos,
      });
      this.$router.push({ path: '/continuar-pago' });
    },
  },
  mounted() {
    this.generateRef();
  },
};
</script>

<style lang="scss" scoped>
#pagar-container {
  .payment-row {
    height: 60px;
    justify-content: center;
    align-items: center;
  }
  .logo-bbva, .logo-santander {
    height: 60px;
    display: flex;
    justify-content: center;
  }
  .logo-santander {
    img {
      height: 60px;
    }
  }
  .logo-bbva {
    img {
      height: 50px;
    }
  }
  .el-divider {
    height: 3px;
  }
  .el-button {
    background-color: #884E93;
    &:hover {
      opacity: 0.9;
    }
  }
  .cart-wrapper {
    margin: 10px 0px;
    border: solid #f0f0f0;
    border-width: 1px;
    .cart-title {
      border-radius: 5px 5px 0px 0px !important;
      background-color: #333333;
      color: #FFFFFF;
      padding: 10px;
      .cart-title__inner {
        font-size: 14px;
        padding: 0px !important;
        margin: 0px !important;
      }
    }
    .custom-table {
      padding-left: 10px;
      padding-right: 10px;
      .custom-row {
        display: flex;
        flex-direction: row;
        padding-top: 10px;
        padding-bottom: 10px;
        overflow: hidden;
        text-transform: uppercase;
        border: solid;
        border-width: 0px;
        border-bottom-width: 1px;
        border-color: #f0f0f0;
        &:last-child {
          border-bottom-width: 0px !important;
          .custom-row__value {
            text-align: right;
          }
        }
        .custom-row__field {
          color: #606266;
          min-width: 120px;
          width: 100%;
        }
        .custom-row__value {
          color: #0a0a0a;
          min-width: 120px;
          width: 100%;
        }
      }
    }
  }
  .legend {
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
    margin: 0;
    padding: 0;
    font-size: 16px;
    margin-bottom: 10px;
    color: #606266;
  }
  @media screen and (max-width: 576px) {
    .cart-title {
      text-align: center;
    }
    .xs-display-unset {
      display: block !important;
      height: 90px;
      .el-button:first-of-type {
        margin-top: 5px;
      }
      img {
        margin-top: 10px;
      }
    }
  }
}
</style>
